export var HeaderFooterStyle;
(function (HeaderFooterStyle) {
    HeaderFooterStyle[HeaderFooterStyle["BRANDED"] = 10] = "BRANDED";
    HeaderFooterStyle[HeaderFooterStyle["LIGHT"] = 20] = "LIGHT";
    HeaderFooterStyle[HeaderFooterStyle["DARK"] = 30] = "DARK";
})(HeaderFooterStyle || (HeaderFooterStyle = {}));
//# sourceMappingURL=header-footer-style.enum.js.map